export default "__VITE_ASSET__ced1089c__"